import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Card, Row, Col, Badge } from 'react-bootstrap'
import LoadingSpinner from '../LoadingSpinner';
//import fetchDashboardInformation from '../../../webservices/seacom/dashboard/dashboardWs';
import { ToastTypes } from '../modals/FuseToast';

class IconCard extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            loading:true,
            count: 0
        };
    } 

    displayCol = (aggregate) => {
      switch(aggregate){
        case 'COUNT': {return 'count_id';}
        default: {return ''}
      }
    }
  
    static defaultProps = {
    }

    render(){
        return <div className="card-deck p-4">
            <Card className='fuseHover p-0 stats-card' bg={this.props.variant}>
            <Card.Link href={this.props.url}>
                <Card.Body>
                    <Row>
                        { this.state.loading ? <>
                            <Col>
                                <LoadingSpinner/>
                            </Col>
                        </> : <>
                            <Col xs={2} className='align-middle'>
                                <i className={`fa ${this.props.icon} fa-3x`}></i>
                            </Col>
                            <Col xs={8}  className="text-center align-middle">
                                <h5>{this.props.title}</h5>
                            </Col>
                            <Col className='align-middle'>
                                <h3 ><Badge variant="light" bg="secondary" pill>{this.state.count}</Badge></h3>
                            </Col>
                        </>}
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <br/>
                            <p>
                                {this.props.description}
                            </p>
                        </Col>
                    </Row>
                </Card.Body>
            </Card.Link>
        </Card>
    </div>;
    } 

    
    componentDidMount = () =>{
        this.fetchCardInformation();
    }

    
    componentDidUpdate(prevProps) {
        if (!_.isEqual(this.props, prevProps))
            this.fetchCardInformation();
    }

    fetchCardInformation = () =>{

      var payload = {
        "table_name":this.props.tableName,
        "aggregate_col" : this.props.aggregateCol,
        "aggregate": this.props.aggregate,
        "values": this.props.values
    }

        // fetchDashboardInformation(payload).then(
        //   (response) => {
        //     if (!_.isEmpty(response.error)) {
        //       console.log("Error fetching dashboard information");
        //       console.log(JSON.stringify(response.error));
        //       this.props.addToast(ToastTypes.ERROR, "Error fetching dashboard information");
        //     } else if (response.data.success === true){
        //       var data = response.data.result;
        //       this.setState({ count: data[0][this.displayCol(this.props.aggregate)] });
        //     } else {
        //       console.log("Error fetching dashboard information");
        //       console.log(JSON.stringify(response.data));
        //       this.props.addToast(ToastTypes.ERROR, "Error fetching dashboard information");
        //     }    
        //   }
        // ).catch(function (error) {
        //   console.log("exception:" + error);
        // });
        
        this.setState({loading: false});
    }
}

const mapStateToProps = (state) => {
    return{
        fetchingData: state.fetchingData === true
    };
}

export default  connect(
    (mapStateToProps), 
    (dispatch, ownProps) => ({})
    )(IconCard);